import request from "../utils/request";

export function getCompanyRequirements(companyId, category, pagination) {
  return request({
    url: `/requirements/${companyId}/categories/${category}`,
    method: "get",
    params: pagination,
  });
}

export function updateCompanyRequirements(companyId, category, data) {
  return request({
    url: `/requirements/${companyId}/categories/${category}`,
    method: "patch",
    data,
  });
}

export function getCompanyRequirementCategories(companyId) {
  return request({
    url: `/requirements/${companyId}/categories`,
    method: "get",
  });
}

export function getRequirementCategories() {
  return request({
    url: `/requirements/categories`,
    method: "get",
  });
}

export function getRequirementCategory(id) {
  return request({
    url: `/requirements/categories/${id}`,
    method: "get",
  });
}
